import axios from 'axios'

// Separate client and token. A referral session never inherits employer credentials.
const client = axios.create({ baseURL: process.env.VUE_APP_PICKED_API_ENDPOINT })
const key = 'tc.referral.session'
const request = (method, path, data) => client.request({
  method,
  url: `assessment/referrals/${path}`,
  data,
  headers: { Authorization: `Bearer ${window.localStorage.getItem(key) || ''}` }
}).then(response => response.data.data)

export default {
  offer: () => request('get', 'offer'),
  invite: code => request('get', `invite/${encodeURIComponent(code)}`),
  dashboard: () => request('get', 'dashboard'),
  requestLink: (email, acceptTerms, version) => request('post', 'request-link', { email, accept_terms: acceptTerms, terms_version: version }),
  async exchange (token) {
    const result = await request('post', 'exchange', { token })
    window.localStorage.setItem(key, result.token)
  },
  hasSession: () => !!window.localStorage.getItem(key),
  clearSession: () => window.localStorage.removeItem(key),
  async logout () {
    await request('post', 'logout')
    window.localStorage.removeItem(key)
  }
}
